import { renderButtonContent } from 'components/Button/renderButtonContent';
import { forwardRef } from 'react';
import type { AnchorHTMLAttributes } from 'react';
import './Button.css';
import classNames from 'classnames';
import type { ButtonProps } from './Button';
import { getButtonClassNames } from './getButtonClassNames';

type Props = Omit<ButtonProps, 'type'> &
  AnchorHTMLAttributes<HTMLAnchorElement>;

export const ButtonAnchor = forwardRef<HTMLAnchorElement, Props>(
  (
    {
      accent,
      disabled,
      className,
      size,
      variant,
      children,
      icon,
      iconStyle,
      iconPosition,
      loading,
      ...restProps
    },
    ref,
  ) => (
    <a
      className={getButtonClassNames(
        children,
        variant,
        classNames(className, 'button--anchor'),
        accent,
        size,
      )}
      ref={ref}
      {...restProps}
    >
      {renderButtonContent({
        children,
        icon,
        iconStyle,
        iconPosition,
        loading,
        size,
      })}
    </a>
  ),
);

ButtonAnchor.displayName = 'ButtonAnchor';
